import React, { type CSSProperties, useMemo } from 'react';

import { type TBlock } from '@wp-block-builder/package';

import { type TColumnsSectionBlockProps } from '../types';

import { getPaddingAfter, getPaddingBefore } from './cssProperties';

type Props = {
  blockProps: TColumnsSectionBlockProps;
  index: number;
  renderChildBlock: (block: TBlock | null, index: number) => JSX.Element;
};
export default function StackedTableCell({ index, renderChildBlock, blockProps }: Props) {
  const style = useMemo<CSSProperties>(
    () => ({
      width: '100%',
      paddingTop: getPaddingBefore(index, blockProps),
      paddingBottom: getPaddingAfter(index, blockProps),
    }),
    [index, blockProps]
  );
  return (
    <div className="block-mobile" style={style}>
      {renderChildBlock(blockProps.blocks[index], index)}
    </div>
  );
}
